const MAX_EARLY_ERRORS = 20;

export function scheduleSentry() {
  if (window.__sentryInitialized || window.__sentryLoadScheduled) return;
  window.__sentryLoadScheduled = true;

  // Preserve errors raised while the monitoring bundle is still loading.
  const errors = [];
  const remember = (error) => {
    if (!window.__sentryInitialized && errors.length < MAX_EARLY_ERRORS) errors.push(error);
  };
  const onError = (event) => {
    if (event.error || event.message) remember(event.error || new Error(event.message));
  };
  const onRejection = (event) => remember(event.reason);
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  const load = async () => {
    try {
      // Propshaft resolves this to the fingerprinted asset in development and
      // production. A separate entrypoint keeps Sentry out of the funnel bundle.
      const sentry = await import(RAILS_ASSET_URL('sentry.js'));
      sentry.initSentry();
      if (window.__sentryInitialized) errors.forEach(error => sentry.captureException(error));
    } catch (error) {
      window.__sentryLoadScheduled = false;
      console.warn('Error monitoring could not be loaded', error);
    } finally {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
      errors.length = 0;
    }
  };

  const schedule = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 2000 });
    } else {
      window.setTimeout(load, 0);
    }
  };

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
}
